import { MonoTypeOperatorFunction, of, pipe, switchMap, take } from 'rxjs';

export function customSwitchMap<T>(count?: number): MonoTypeOperatorFunction<T> {
  if (count) {
    return pipe(
      take(count),
      switchMap(data => of(data)),
    );
  }
  return pipe(switchMap(data => of(data)));
}
